import React,{useContext, useState, useRef} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { LocaleContext } from '../../../components/LocaleContext';
import { Checkbox } from "primereact/checkbox";
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
export default function PriorityDepartmentAdd({priority_department, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {setDialogText,setVisible,openFavoriteDialog,setFastView,visible,hasAll} = useContext(UtilContext);
  const { t } = useContext(LocaleContext);
    const [closeTab,setCloseTab] = useState(false);

    const [formPaintingInterval,setFormPaintingInterval] = useState (priority_department);
    const [formType, setFormType] = useState(type);

    const [insertCopyIcon,setInsertCopyIcon] = useState(!user.permissions?.includes('add priorities-setup'));
    const [scrollIcons,setScrollIcons] = useState(!user.permissions?.includes('edit priorities-setup'));
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
const [departments, setDepartments] = useState((priority_department!=null)?priority_department.departments.map((dep) => dep.id):[]);

    const onDepartmentsChange = (e) => {
        let _departments = [...departments];

        if (e.checked)
            _departments.push(e.value);
        else
            _departments.splice(_departments.indexOf(e.value), 1);
            setDepartments(_departments);
    }


    const toast = useRef(null);
    const submitRef = useRef(null);
    function addNewPriorityDepartment(){
        dispatch({type:'create_new_tab',name: t('PriorityDepartmentList.Tab.Add'), translationKey: 'PriorityDepartmentList.Tab.Add', legacyLabel: t('PriorityDepartmentList.Tab.Add'),page:'PriorityDepartmentAdd',props:{priority_department: null,type:'add'},mask:'prio007'})
    }
    function copyPriorityDepartment(){
        dispatch({type:'create_new_tab',name: t('PriorityDepartmentList.Tab.Add'), translationKey: 'PriorityDepartmentList.Tab.Add', legacyLabel: t('PriorityDepartmentList.Tab.Add'),page:'PriorityDepartmentAdd',props:{priority_department: formik.values,type:'copy'},mask:'prio007'})
    };

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues: formPaintingInterval==null?{
            name:'',abbreviation:'',
        }:formPaintingInterval,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            formData.append("name", values["name"]);
            formData.append("abbreviation", values["abbreviation"]);
            for (var i = 0; i < departments.length; i++) {
                formData.append("departments[]", departments[i]);
            }
            if(formType=="add"){
                postRequest("/api/priority_departments", formData,true)
                .then((response) => {
                    console.log(response);
                    getRequest("/api/priority_departments").then((response) => {
                        dispatch({type:'load_priority_departments',newPriorityDepartments:response.data});
                        dispatch({type:'priority_departments_reload',value:true});
                        dispatch({type:'priority_departments_reload',value:false});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        setFormType("edit");
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                postRequest(`/api/priority_departments/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest("/api/priority_departments").then((response) => {
                        dispatch({type:'load_priority_departments',newPriorityDepartments:response.data});
                        dispatch({type:'priority_departments_reload',value:true});
                        dispatch({type:'priority_departments_reload',value:false});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        formik.setValues(values);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    function getIndex(priority_department_id) {
        return state.priority_departments.findIndex(obj => obj.id === priority_department_id);
    }

    async function scrollToFirst(){
        let first = state.priority_departments[0];
        setFormPaintingInterval(first);
    }
    
    async function scrollUp(){
        let id = getIndex(formik.values.id);
        if(id-1>=0){
            setFormPaintingInterval(state.priority_departments[id-1]);
        }
    }
    
    async function scrollDown(){
        let id = getIndex(formik.values.id);
        if(id+1<state.priority_departments.length){
            setFormPaintingInterval(state.priority_departments[id+1]);
        }
    }
    
    async function scrollToLast(){
        let last = state.priority_departments.length-1;
        let lastItem = state.priority_departments[last];
        setFormPaintingInterval(lastItem);
    }


return (

        <div>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="saveandclose"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="save"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewPriorityDepartment()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyPriorityDepartment()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('PriorityDepartmentList.Tab.Add'),"PriorityDepartmentAdd")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("PriorityDepartmentAdd")}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        </IntersectionObserverWrapper>
        </div>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)]">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                { !user.permissions?.includes("edit priorities-setup") && 
                    <div className='w-full h-8 flex justify-center px-2 py-1 mb-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
                            <path d="M 25 3 C 18.363281 3 13 8.363281 13 15 L 13 20 L 9 20 C 7.355469 20 6 21.355469 6 23 L 6 47 C 6 48.644531 7.355469 50 9 50 L 41 50 C 42.644531 50 44 48.644531 44 47 L 44 23 C 44 21.355469 42.644531 20 41 20 L 37 20 L 37 15 C 37 8.363281 31.636719 3 25 3 Z M 25 5 C 30.566406 5 35 9.433594 35 15 L 35 20 L 15 20 L 15 15 C 15 9.433594 19.433594 5 25 5 Z M 9 22 L 41 22 C 41.554688 22 42 22.445313 42 23 L 42 47 C 42 47.554688 41.554688 48 41 48 L 9 48 C 8.445313 48 8 47.554688 8 47 L 8 23 C 8 22.445313 8.445313 22 9 22 Z M 25 30 C 23.300781 30 22 31.300781 22 33 C 22 33.898438 22.398438 34.6875 23 35.1875 L 23 38 C 23 39.101563 23.898438 40 25 40 C 26.101563 40 27 39.101563 27 38 L 27 35.1875 C 27.601563 34.6875 28 33.898438 28 33 C 28 31.300781 26.699219 30 25 30 Z"></path>
                        </svg>
                    </div> }
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.ODDELENIE_PRIORIT')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                <form className="mt-6" onSubmit={formik.handleSubmit}>
                      
                        <div>
                            <label
                                for="name"
                                className="block text-md font-semibold text-gray-800"
                            >{t('DepartmentList.Column.Name')}</label>
                            <input
                                name='name'
                                type="text"
                                onChange={formik.handleChange} value={formik.values.name}
                                readOnly={!user.permissions?.includes("edit priorities-setup")} 
                                className={` ${
                                    user.permissions?.includes("edit priorities-setup") ? "bg-white " : "bg-gray-200 "
                                } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                            />
                        </div>
                        <div>
                            <label
                                for="abbreviation"
                                className="block text-md font-semibold text-gray-800"
                            >
                                Skratka oddelenia
                            </label>
                            <input
                                name='abbreviation'
                                type="text"
                                onChange={formik.handleChange} value={formik.values.abbreviation}
                                readOnly={!user.permissions?.includes("edit priorities-setup")} 
                                className={` ${
                                    user.permissions?.includes("edit priorities-setup") ? "bg-white " : "bg-gray-200 "
                                } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                            />
                        </div>
                        <div className='grid grid-cols-2'>
                            {state.departments.map((department) => 
                                <div className="flex align-items-center">
                                    <Checkbox inputId={department.id} name="departments" value={department.id} onChange={onDepartmentsChange} checked={departments.includes(department.id)} />
                                    <label htmlFor={department.id} className="ml-2">{department.name}</label>
                                </div>
                            )}
                        </div>
                        
                        <button type="submit" ref={submitRef} className='hidden'></button>      
                </form>              
            </div>
            </div>
            </div>
            <Dialog visible={visibleLoading} style={{ width: '25vw',height:'25vh',backgroundColor: 'transparent',boxShadow: 'none'}} className='mypanel flex flex-row'  closable={false} draggable={false} showHeader={false}>
            <InfinitySpin 
            width='208'
            color="#000"
            />
            <p className='text-2xl font-bold text-center w-52 text-black'>{t('Common.LoadingEllipsis')}</p>
            </Dialog>
</div>
            );
} 
